import React, { useContext, useEffect, useState } from "react";
import {Col, Empty, Row, Table, Tooltip, Input} from "antd";
import {LoadingOutlined, EyeOutlined, HomeOutlined, ApartmentOutlined} from "@ant-design/icons";
import Colors from "@dwellpass-client/common/utils/constants/Colors";
import {gql, useQuery} from "@apollo/client";
import {CommunityContext} from "@dwellpass-client/common/contexts/CommunityContext";
import ResourceQueries from "@dwellpass-client/common/utils/constants/queries/ResourceQueries";
import {UnitContext} from "@dwellpass-client/common/contexts/UnitContext";

const { Search } = Input;

const MainResourcesTable = (props) => {
    const resourcePageSize = 30;

    const [communityState, _] = useContext(CommunityContext);
    const [unitState, ] = useContext(UnitContext);
    const [resourcesState, setResourcesState] = useState([]);
    const [totalResourceCount, setTotalResourceCount] = useState(0);
    const [pageOffsetState, setPageOffsetState] = useState(null);
    const [searchTextState, setSearchTextState] = useState("");

    const { data: resourceData, refetch: refetchResources, loading: loadingResources } = useQuery(gql(ResourceQueries.getResourcesForResident), { notifyOnNetworkStatusChange: true, variables: { communityId: communityState.id, residentViewable: true, resourceableNilOrId: unitState.id, searchTerm: searchTextState, first: resourcePageSize, after: pageOffsetState } } );

    useEffect(() => {
        if(resourceData) {
            setResourcesState(resourceData.resources);
            setTotalResourceCount(resourceData.resources.totalCount);
        }
    }, [resourceData]);

    useEffect(() => {
        refetchResources();
    }, [pageOffsetState, searchTextState]);

    const changeResourceTablePage = (page, pageSize) => {
        setPageOffsetState(btoa((page-1)*pageSize));
    }

    const columns = [
        {
            title: 'File',
            key: 'name',
            dataIndex: ['node', 'name'],
            render: (text, record) => (
                <Row wrap={false}>
                    <span style={{ whiteSpace: "nowrap" }}>{record.node.name ? record.node.name : record.node.resourceFileName}</span>
                    {record.node.resourceFileUrl ?
                        record.node.description &&
                        <span style={{color: Colors.monoMedLightGrey, textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden"}}>&nbsp; - {record.node.description}</span>
                        :
                        <span style={{color: Colors.monoMedLightGrey, textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden"}}>&nbsp; - Select to View</span>
                    }
                </Row>
            ),
        },
        {
            title: 'Assigned',
            key: 'resourceable',
            dataIndex: ['node', 'resourceable'],
            width: 200,
            render: (text, record) => (
                record.node.resourceable ?
                    <Row wrap={false} align="middle">
                        <Col>
                            <HomeOutlined style={{marginRight: 10, fontSize: 20, color: Colors.brandPrimary}}/>
                        </Col>
                        <Col>
                            <span style={{textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden"}}>This Unit</span>
                        </Col>
                    </Row>
                    :
                    <Row wrap={false} align="middle">
                        <Col>
                            <ApartmentOutlined style={{marginRight: 10, fontSize: 20, color: Colors.brandPrimary}}/>
                        </Col>
                        <Col>
                            <span style={{textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden"}}>Community</span>
                        </Col>
                    </Row>
            ),
        },
        {
            title: 'View',
            key: 'viewFile',
            width: 80,
            render: (text, record) => (
                record.node.resourceFileUrl ?
                    <a href={record.node.resourceFileUrl} onClick={(e) => {e.stopPropagation();}} target="_blank"><EyeOutlined style={{fontSize: 22}} /></a>
                :
                    <Tooltip title={record.node.description}>
                        <EyeOutlined style={{ marginTop: 4, fontSize: 22, color: Colors.brandPrimary }} />
                    </Tooltip>

            ),
        }
    ];

    return(
        <>
            <Row style={{ minHeight: 42 }} justify="end" align="middle">
                <Col>
                    <Search style={{ width: 200 }} placeholder="Search text..." allowClear onSearch={(term) => setSearchTextState(term)} />
                </Col>
                <Col>
                    {loadingResources &&
                        <LoadingOutlined style={{marginLeft: 15, marginRight: 15, fontSize: 20, color: Colors.brandPrimary}}/>
                    }
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <Table
                        columns={columns}
                        dataSource={resourcesState ? resourcesState.edges : null}
                        loading={{spinning: loadingResources, indicator: <LoadingOutlined style={{ color: Colors.brandPrimary, fontSize: 40, marginLeft: -20 }} />}}
                        rowKey={record => record.node.id}
                        pagination={{
                            pageSize: resourcePageSize,
                            position: ["none", "bottomCenter"],
                            total: totalResourceCount,
                            onChange: (page, pageSize) => { changeResourceTablePage(page, pageSize) }
                        }}
                        scroll={{ y: "58vh" }}
                        locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No Resources Found" /> }}
                        onRow={(record) => {
                            return {
                                onClick: event => { props.selectResource(record) }
                            };
                        }}
                    />
                </Col>
            </Row>
        </>
    )
}

export default MainResourcesTable;